<template>
  <div class="gdlist-component-container">
    <div v-if="finish && dataList.length == 0" class="empty-item" style="padding: 50px 0;">
      <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
    </div>
    <div v-else class="data-list-item">
      <div class="data-item" v-for="(item, index) in dataList" :key="index" @click="handleShowDetail(item)">
        <div class="status" :class="item.Status == 1 ? 'status1' : ''">{{ item.Status == 1 ? '已完成' : '待处理' }}</div>
        <div class="class-item">{{ item.CnClassName }}</div>
        <div class="time">{{ $TOOL.dateFormat(item.AddTime * 1000) }}</div>
        <div class="desc">{{ item.Desc }}</div>
        <div class="icon img-cover"><img src="../../assets/pc-images/view-icon.png" /></div>
      </div>
      <div v-if="!finish && dataList.length > 0" class="more-goods-btn" @click="handleGetDataList">
        <van-loading v-if="loading" size="20" color="#5783fc" />
        <span v-else>查看更多</span>
      </div>
    </div>
    <contentGdDetailComponent v-if="showGdDetail" ref="contentGdDetailComponentRef" @onClose="showGdDetail = false" />
  </div>
</template>


<script>
import contentGdDetailComponent from './ContentGdDetailComponent.vue';
export default {
  name: "ContentGdListComponent",
  components: {
    contentGdDetailComponent
  },
  data() {
    return {
      PageCount: 10,
      Page: 1,
      loading: false,
      finish: false,
      dataList: [],
      showGdDetail: false
    }
  },
  mounted() {
    this.handleGetDataList()
  },
  methods: {
    handleShowDetail(data) {
      this.showGdDetail = true
      this.$nextTick(() => {
        this.$refs.contentGdDetailComponentRef.open(data)
      })
    },
    async handleGetDataList() {
      const { PageCount, Page, dataList, finish, loading } = this
      if (finish || loading) {
        return
      }
      const params = {
        PageCount,
        Page
      }
      this.loading = true
      var res = await this.$API.ticketsList.post(params)
      this.dataList = [
        ...dataList,
        ...res.info
      ]
      this.Page = Page + 1
      this.finish = res.info.length < PageCount
      this.loading = false
    },
  }
}
</script>

<style lang="less" scoped>
.data-list-item {
  padding-bottom: 50px;
  .data-item {
    padding: 12px 15px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    cursor: pointer;
    .status {
      position: absolute;
      top: 0;
      right: 0;
      width: 65px;
      height: 25px;
      border-radius: 0 5px 0 5px;
      background-color: #fa0c11;
      color: #fff;
      font-size: 12px;
      line-height: 25px;
      text-align: center;
      &.status1 {
        background-color: #16a34a;
      }
    }
    .class-item {
      line-height: 40px;
      font-size: 18px;
      font-weight: 500;
      color: #393942;
    }
    .time {
      color: #64748b;
      font-size: 12px;
      line-height: 18px;
    }
    .desc {
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 5px;
      color: #64748b;
      line-height: 20px;
    }
    .icon {
      position: absolute;
      width: 16px;
      height: 16px;
      bottom: 12px;
      right: 15px;
    }
  }
}
.more-goods-btn {
  margin: 20px auto 50px;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>